import {UserPermissionFilterInterface} from '@spa/api';
import {ComponentTypesEnum} from 'appShared/enums';
import {BaseControl, SelectControl} from 'appShared/classes/controls';
import {SelectOptionInterface} from 'appShared/components';

type OperatorPermissionFilterType = string | number | boolean | object;

export const OPERATOR_DEPARTMENT_KEY = 'Department';

export const getSelectedOperatorDepartmens = (permissions: UserPermissionFilterInterface[]): string[] => {
    const departmentPermissions = permissions.filter(permission => permission.filter_key === OPERATOR_DEPARTMENT_KEY);

    if (!departmentPermissions || departmentPermissions.length === 0) {
        return [];
    }

    const departmentList = [].concat(...departmentPermissions.map(permission => permission.values));
    if (!departmentList || departmentList.length === 0) {
        return [];
    }

    return departmentList;
};

export const getAllOperatorDepartmens = (permissions: UserPermissionFilterInterface[]): string[] => {
    const departmentPermissions = permissions.filter(permission => permission.filter_key === OPERATOR_DEPARTMENT_KEY);

    if (!departmentPermissions || departmentPermissions.length === 0) {
        return [];
    }

    const departmentList = departmentPermissions[0].existing_values;
    if (!departmentList || departmentList.length === 0) {
        return [];
    }

    return departmentList;
};

export const OperatorPermissionFilterControls = (): BaseControl<OperatorPermissionFilterType>[] => {
    return [];
};

export const prepareDepartmentSelect = (filterId: number, isDynamic: boolean): SelectControl => {
    return new SelectControl({
        name: String(filterId),
        value: null,
        placeholder: 'Department',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: [],
        multiple: true,
        isDynamic
    });
};

export const prepareDepartmentOptions = (data: string[]): SelectOptionInterface[] => {
    if (!data || data.length === 0) {
        return [];
    }

    return data.map((item: string) => {
        return {
            label: item,
            value: item
        };
    });
};
